import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexCenter, LineClamp } from '../../global/commonStyle';

interface Props {
  isActive?: boolean;
  isWithoutBg?: boolean;
  isDisabled?: boolean;
}

const TabCloseIcon = styled.div`
  display: none;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right: 3px;
  &:hover {
    background-color: var(--icon-hover-background);
    svg {
      path {
        fill: var(--text-primary);
      }
    }
  }
`;
const Tabs = styled.div<Props>`
  -webkit-app-region: no-drag;
  position: relative;
  padding: var(--space-3) var(--space-20) var(--space-3) var(--space-12);
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  background-color: var(--tabs-background);
  border-radius: var(--border-radius-8);
  &:hover {
    background-color: var(--tabs-hover-background);

    ${TabCloseIcon} {
      display: flex;
    }
  }
  ${(props) =>
    props.isActive &&
    css`
      background-color: var(--tabs-hover-background);
    `}

  ${(props) =>
    props.isWithoutBg &&
    css`
      -webkit-app-region: drag;
      cursor: auto;
      background-color: transparent;
      &:hover {
        background-color: transparent;
      }
    `}
`;
const Icon = styled.div`
  width: 18px;
  height: 18px;
  .transparent-fill {
    fill: transparent;
  }

  .task-open-icon {
    width: 19px;
    path {
      fill: var(--text-secondary);
    }
    path.first-path {
      fill: transparent;
    }
  }
`;
const TabsName = styled.div`
  ${FlexCenter}
  gap: var(--space-8);
  width: 100%;
  p {
    color: var(--text-primary);
    margin: var(--space-0);
    ${Typography.body_md_medium};
    ${LineClamp(1)}
    word-break: break-all;
  }
  .task-todo-icon {
    path.desktop-fill {
      fill: transparent;
    }
  }
`;

const PlusIcon = styled.div<Props>`
  -webkit-app-region: no-drag;
  padding: var(--space-4);
  ${FlexCenter}
  border-radius: var(--border-radius-8);
  background-color: var(--tabs-background);
  cursor: pointer;
  &:hover {
    background-color: var(--tabs-hover-background);
    svg {
      fill: var(--text-primary);
      path {
        fill: var(--text-primary);
      }
    }
  }
  ${(props) =>
    props.isDisabled &&
    css`
      cursor: not-allowed;
      &:hover {
        background-color: var(--tabs-background);
        svg {
          path {
            fill: var(--text-tertiary);
          }
        }
      }
      svg {
        path {
          stroke: var(--text-tertiary);
        }
      }
    `}
`;
const TabsBarSection = styled.div`
  display: none;
  gap: var(--space-6);
  padding: var(--space-6) var(--space-6) var(--space-0) var(--space-0);
  position: relative;
  width: 100%;
`;
const ActionSection = styled.div`
  display: none;
  gap: var(--space-6);
  max-width: 160px;
  width: 100%;
  align-items: center;
  justify-content: end;
  padding: var(--space-4) var(--space-16) var(--space-0) var(--space-13);
`;
const MacHeader = styled.div`
  ${AlignCenter}
  position: relative;
`;
const WindowsHeaderIcon = styled.div`
  -webkit-app-region: no-drag;
  padding: var(--space-5);
  cursor: pointer;
  ${FlexCenter}
  border-radius: var(--border-radius-10);
  &:hover {
    background-color: var(--background-hover-navbar-windows);
    svg path {
      fill: var(--text-primary);
    }
  }
  .forward-icon {
    transform: rotate(180deg);
  }
`;
const ExpandCloseSection = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  margin-left: var(--space-24);
  display: none;
`;
const NavigateArea = styled.div`
  display: none;
  align-items: center;
  gap: var(--space-8);
  width: 100%;
`;
const LogoIcon = styled.div`
  width: 24px;
  height: 24px;
  svg {
    path {
      fill: var(--text-secondary);
    }
  }
`;
const ArrowSection = styled.div`
  display: flex;
  gap: var(--space-4);
  -webkit-app-region: no-drag;
`;
const BackArrowIcon = styled.div`
  -webkit-app-region: no-drag;
  padding: var(--space-5);
  border-radius: var(--border-radius-10);
  cursor: pointer;
  ${FlexCenter}
  &:hover {
    background-color: var(--background-hover-navbar-windows);
    svg path {
      fill: var(--text-primary);
    }
  }
  .forward-icon {
    transform: rotate(180deg);
  }
`;

export {
  Tabs,
  Icon,
  TabsName,
  TabCloseIcon,
  PlusIcon,
  TabsBarSection,
  ActionSection,
  MacHeader,
  WindowsHeaderIcon,
  ExpandCloseSection,
  LogoIcon,
  NavigateArea,
  ArrowSection,
  BackArrowIcon
};
